module.exports = __webpack_public_path__ + "01f43047/img/arrow-left-icon.785c715c.svg";